import { resolveAudience, safeReturnTo } from './session';

export function readResearchCloudLaunch(raw: Record<string, unknown>) {
  return {
    sessionID: typeof raw.sessionID === 'string' ? raw.sessionID : '',
    audience: typeof raw.audience === 'string' ? raw.audience : typeof raw.adnc === 'string' ? raw.adnc : undefined,
    next: safeReturnTo(raw.next),
  };
}

export async function exchangeResearchCloudSession(sessionID: string, audience?: string) {
  if (!/^[A-Za-z0-9_-]{16,256}$/.test(sessionID)) throw new Error('This Research Cloud launch link is invalid. Please launch AskBell from Research Cloud again.');
  const resolvedAudience = resolveAudience(audience);
  const response = await fetch('/api/auth/sso', {
    method: 'POST', credentials: 'omit', referrerPolicy: 'no-referrer',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ sessionID, audience: resolvedAudience }),
    signal: AbortSignal.timeout(25_000),
  });
  const result = await response.json() as { accessToken?: unknown; error?: { message?: string } };
  if (!response.ok) throw new Error(result.error?.message || 'Research Cloud could not verify your session. Please launch AskBell again.');
  if (typeof result.accessToken !== 'string' || !result.accessToken) throw new Error('Research Cloud did not return a valid session. Please launch AskBell again.');
  return { accessToken: result.accessToken, audience: resolvedAudience };
}
